import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePortfolioData } from '../contexts/DataContext';
import { MapPin, ArrowRight, Mail, Download } from 'lucide-react';

const Hero = () => {
  const { t } = useLanguage();
  const { loading } = usePortfolioData();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  if (loading) return <section className="min-h-screen bg-black flex items-center justify-center"><div className="animate-pulse text-lime-400 text-2xl">Loading...</div></section>;

  return (
    <section data-testid="hero-section" className="hero-section min-h-screen bg-black flex items-center justify-center relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23d9fb06' fill-opacity='0.1'%3E%3Ccircle cx='7' cy='7' r='1'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }} />
      </div>
      <div className="container max-w-7xl mx-auto px-8 py-20 relative z-10">
        <div className="text-center">
          <p className="text-gray-400 text-base md:text-lg mb-4 font-medium tracking-wide">{t('hero.greeting')}</p>
          <h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-black text-lime-400 uppercase leading-none mb-6 tracking-tight">
            {t('hero.name').split(' ').map((word, i) => <span key={i} className="block">{word}</span>)}
          </h1>
          <h2 className="text-base md:text-lg text-gray-300 font-semibold mb-4 max-w-4xl mx-auto">{t('hero.title')}</h2>
          <p className="text-sm md:text-base text-gray-400 mb-8 max-w-3xl mx-auto leading-relaxed">{t('hero.subtitle')}</p>
          <div className="flex items-center justify-center space-x-2 mb-10">
            <MapPin className="text-lime-400" size={20} />
            <span className="text-gray-300 font-medium text-sm">{t('hero.location')}</span>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button onClick={() => scrollToSection('experience')} data-testid="hero-cta-btn" className="bg-lime-400 text-black hover:bg-lime-300 px-8 py-4 rounded-full font-bold text-base uppercase tracking-wide transition-all duration-300 transform hover:scale-105 flex items-center space-x-2">
              <span>{t('hero.cta')}</span><ArrowRight size={20} />
            </button>
            <a href="/cv_JP_en.pdf" download="Joao_Paulo_Belatto_CV.pdf" data-testid="hero-download-cv-btn" className="border-2 border-lime-400 text-lime-400 hover:bg-lime-400 hover:text-black px-8 py-4 rounded-full font-bold text-base uppercase tracking-wide transition-all duration-300 transform hover:scale-105 flex items-center space-x-2">
              <Download size={20} /><span>{t('hero.downloadCv')}</span>
            </a>
            <button onClick={() => scrollToSection('contact')} data-testid="hero-contact-btn" className="border-2 border-gray-600 text-gray-300 hover:border-lime-400 hover:text-lime-400 px-8 py-4 rounded-full font-bold text-base uppercase tracking-wide transition-all duration-300 transform hover:scale-105 flex items-center space-x-2">
              <Mail size={20} /><span>{t('hero.contact')}</span>
            </button>
          </div>
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-lime-400 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-lime-400 rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
